"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IncidentStoryCategory = void 0;
exports.IncidentStoryCategory = {
    INCIDENT_AFFECTATION: 'INCIDENT_AFFECTATION',
    INCIDENT_OPEN: 'INCIDENT_OPEN',
    INCIDENT_SOLVED: 'INCIDENT_SOLVED',
    INCIDENT_AUTO_SOLVED: 'INCIDENT_AUTO_SOLVED',
    INCIDENT_RE_OPEN: 'INCIDENT_RE_OPEN',
};
